import {styled, ThemeableStack} from "tamagui";

export const LmAspectRatio = styled(ThemeableStack, {})